<template>
  <!-- 隐私协议阅读查看弹窗 -->
  <div>
    <mt-popup v-model="popupVisible" position="bottom" class="yz-ems-right-explain-wrap" :closeOnClickModal="false">
      <div class="header">
        <span>服务协议</span>
        <i class="iconfont icon-close close-icon" @click="handleClose" />
        <!-- <img class="close-icon" src="https://ump.ems.com.cn/newmail-resources/images/base/icon-close.svg"
          @click.stop="handleClose" alt="" /> -->
      </div>
      <div class="content-wrap">
        <div class="introduce-page">
          <ul class="tabs">
            <li v-for="(item, index) in agreementList" :key="index" class="tab-item"
              :class="{ active: activeTab === index }" @click.stop="selectTab(index)">
              {{ item.noticeTitle }}
            </li>
          </ul>
          <!-- 协议右侧内容 -->
          <div ref="richTextRef" class="rich-content-box" @scroll="handleScroll">
            <div class="rich-content" v-html="agreementList[activeTab] && agreementList[activeTab].noticeContent"></div>
            <!-- 查看隐私协议历史版本的按钮 -->
            <div v-if="agreementList.length === 5 && activeTab === 3" class="history-btn-wrap">
              <div class="history-btn" @click.stop="searchHistory">
                <span class="btn-text">查看历史版本</span>
                <img class="right-icon" src="../../assets/images/icon-arrow-right-gray.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="returnBg footer-btn">
        <div class="returnBtn" @click.stop="handleSignProtocol()" :class="{ 'disable': !isFinishScroll }">我已阅读并同意</div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import { getAllProtocolJson, handleExit, isSignedLatestAgreement, signAgreement } from '@/plugin/util/apiProtocol.js'
import { mapState } from 'vuex'

export default {
  props: {
    popupVisible: {
      default: true
    }
  },
  data () {
    return {
      activeTab: 0,
      agreementList: [],
      isFinishScroll: false,
      throttleFn: () => { }
    }
  },
  computed: {
    ...mapState('protocol', {
      isShowContent: state => state.isShowContent
    })
  },
  methods: {
    // 判断当前协议是否滚动到底部
    isScrollBottom () {
      const richText = this.$refs.richTextRef
      const contentHg = richText.scrollHeight
      const scrollHg = richText.scrollTop
      const clientHg = richText.clientHeight
      const isBottomFlag = clientHg + scrollHg >= contentHg
      if (isBottomFlag && this.activeTab < this.agreementList.length - 1) {
        // 滚动到底部后自动切换到下一个协议tab
        this.activeTab++
        richText.scrollTop = 0
      }
      if (isBottomFlag && this.activeTab >= this.agreementList.length - 1) {
        // 滚动结束
        this.isFinishScroll = true
      }
    },
    throttle (fn, times) {
      let time = null
      return () => {
        let args = Array.from(arguments)
        if (time === null) {
          time = setTimeout(() => {
            fn(...args)
            clearTimeout(time)
            time = null
          }, times)
        }
      }
    },
    // 协议滚动时触发
    handleScroll () {
      this.throttleFn()
    },
    // 关闭弹窗
    handleClose () {
      // 关闭隐私协议查看弹窗时不关闭隐私声明更新提示弹窗
      this.$emit('close')
      this.$store.commit('protocol/setShowContent', false)
      // 重新弹出隐私声明更新的提示弹窗
      this.$emsMsgBox({
        title: '隐私声明更新通知',
        message: `<p style='color: #333333; font-size:14px; font-weight: 400; line-height: 20px; margin-top:10px; margin-bottom:6px;'>尊敬的用户您好，EMS中国邮政速递物流的隐私声明内容有更新，请查看更新后的隐私内容</p>`,
        showCancelButton: true,
        confirmButtonText: '立即查看',
        cancelButtonText: '取消并退出',
        confirmButtonClasses: 'confirm-btn',
        cancelButtonClasses: 'cancel-btn',
        messageContentClass: 'protocol-box-content',
        contentClasses: 'protocol-content',
        closeOnClickModal: false
      }).then(async (action) => {
        if (action === 'confirm') {
          this.$store.commit('protocol/setShowContent', true)
        } else {
          // 退出登录
          handleExit()
        }
      })
    },
    // 查看历史版本
    searchHistory () {
      // this.$router.push('/historyProtocol')
      // this.$store.commit('protocol/setShowContent', false)
      const NODE_ENV = process.env.VUE_APP_NODE_ENV
      let url = 'https://ump.ems.com.cn/newmail-release/expandMenu/introduce/index.html#/protocol/historyList'
      if (NODE_ENV === 'production') {
        url = 'https://ump.ems.com.cn/newmail-api/expandMenu/introduce/index.html#/protocol/historyList'
      }
      window.location.href = url
    },
    selectTab (index) {
      this.activeTab = index
    },
    // 初始化展示的协议内容
    async init () {
      this.throttleFn = this.throttle(this.isScrollBottom, 500)
      const data = await getAllProtocolJson()
      this.agreementList = data
    },
    // 协议签署
    async handleSignProtocol () {
      console.log('handleSignProtocol-isFinishScroll:', this.isFinishScroll)
      if (!this.isFinishScroll) {
        // this.$toast({
        //   message: '请向下拖动阅读全文',
        //   position: 'middle',
        //   className: 'protocol-toast'
        // })
        return
      }
      const { privacy } = await isSignedLatestAgreement({ types: ['privacy'] })
      console.log('签署协议弹窗', privacy)
      console.log('当前协议列表；；', this.agreementList)

      const privacyObj = this.agreementList.find(item => item['versionId'])
      if (!privacy && privacyObj) {
        const res = await signAgreement({ type: 'privacy', versionIdList: [privacyObj.versionId] }) // 签署逻辑
        if (res && res.code === '000000') {
          // this.$toast({
          //   message: '签署成功',
          //   position: 'middle',
          //   className: 'protocol-toast'
          // })
          this.$store.commit('protocol/setShowContent', false)
          this.$store.commit('protocol/setShowNotice', false)
        }
      }
    }
  },
  mounted () {
    this.init()
  }
}

</script>
<style lang="scss">
.protocol-toast {
  z-index: 9999 !important;
}
</style>
<style lang="scss" scoped>
.yz-ems-right-explain-wrap {
  border-top-left-radius: torem(8px);
  border-top-right-radius: torem(8px);

  .header {
    position: relative;
    display: flex;
    height: torem(50px);
    align-items: center;
    justify-content: center;
    color: #333;
    font-size: torem(16px);
    font-weight: 600;

    .close-icon {
      position: absolute;
      top: torem(13px);
      right: torem(14px);
      width: torem(24px);
      height: torem(24px);
      color: #999;
      font-size: torem(24px);
      font-weight: 400;
    }
  }

  .content-wrap {
    height: torem(520px);
    padding-bottom: torem(62px);
    background-color: #fafafa;
  }

  .introduce-page {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    background-color: #f3f4f5;

    .tabs {
      width: torem(110px);
      height: 100%;
      background-color: #f3f4f5;
      color: #333;
      line-height: 1;
      overflow-y: auto;

      .tab-item {
        position: relative;
        padding: torem(11px) torem(10px) torem(11px) torem(14px);
        font-size: torem(12px);
        font-weight: 400;
        line-height: torem(18px);

        &.active {
          background-color: #fff;
          color: #ff9000;

          &::before {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            width: torem(3px);
            height: torem(16px);
            margin: auto;
            background: #ff9000;
            border-radius: torem(6px);
            content: '';
          }
        }
      }
    }

    .rich-content-box {
      height: 100%;
      box-sizing: border-box;
      flex: 1;
      padding: torem(10px);
      background-color: #fff;
      font-size: torem(12px);
      overflow-y: auto;

      .rich-content {
        padding-bottom: torem(20px);
        font-size: torem(12px);
      }
    }
  }

  // 底部
  .returnBg {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: torem(62px);
    box-sizing: content-box;
    box-sizing: border-box;
    padding: torem(9px) torem(16px);
    background-color: #fff;
    box-shadow: 0 -torem(1px) torem(4px) 0 rgba(0, 0, 0, 0.04);
  }

  // 返回按钮
  .returnBtn {
    width: 100%;
    height: torem(44px);
    background-color: #ff9000;
    border-radius: torem(20px);
    color: #fff;
    font-size: torem(16px);
    line-height: torem(44px);
    text-align: center;

    &.disable {
      background-color: #ccc;
      color: #fff;
    }
  }

  // 查看历史版本的按钮
  .history-btn-wrap {
    position: absolute;
    bottom: 0;
    left: torem(110px);
    width: 100%;
    height: torem(60px);
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.8) 35%, #fff 100%);
  }

  .history-btn {
    position: absolute;
    top: torem(20px);
    left: torem(10px);
    display: flex;
    width: torem(245px);
    height: torem(30px);
    align-items: center;
    justify-content: center;
    border: torem(1px) solid #eee;
    background-color: #fff;
    border-radius: torem(4px);
    box-shadow: 0 0 torem(4px) torem(1px) rgba(0, 0, 0, 0.05);

    .btn-text {
      margin-right: torem(2px);
      color: #999;
      font-size: torem(12px);
      font-weight: 400;
      text-align: center;
    }

    .right-icon {
      width: torem(18px);
      height: torem(18px);
    }
  }
}
</style>
